export default "__VITE_ASSET__BR8xOKs5__"